import { NGXLogger } from 'ngx-logger';
import { Injectable, inject } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of, from, switchMap } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { LoadingSiteService } from '../../loading-site/services/loading-site.service';
import { EncryptionService } from 'src/app/services/encryption.service';

@Injectable({
  providedIn: 'root',
})
export class LoadingSiteDetailsResolver implements Resolve<any> {
  private readonly logger = inject(NGXLogger);

  constructor(
    private loadingsiteService: LoadingSiteService, 
    private router: Router,
    private encryptionService: EncryptionService) { }

  // resolve(route: ActivatedRouteSnapshot): Observable<any> {
  //   const encryptedId = route.paramMap.get('id');
  //   if (encryptedId) {
  //     const decodedId = atob(encryptedId); // getLoadingSiteById the ID
  //     return this.loadingsiteService.getLoadingSiteById(decodedId).pipe(
  //       tap((response) => {
  //         console.log(`LoadingSiteDetailsResolver response is ${JSON.stringify(response)}`)
  //       }),
  //       catchError((error) => {
  //         console.error(`LoadingSiteDetailsResolver error is ${JSON.stringify(error)}`);
  //         this.router.navigate(['/error']); // Redirect on error
  //         return of(null);
  //       })
  //     );
  //   } else {
  //     this.router.navigate(['/buyers']);
  //     return of(null);
  //   }
  // }
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const routeId = route.paramMap.get('id');
    if (routeId) {
      this.logger.debug(`[OPAQUE-ID][LoadingSite Resolver] resolving routeId=${routeId}`);
      return this.loadingsiteService.getLoadingSiteById(routeId).pipe(
        tap((response) => {
          this.logger.debug(`[OPAQUE-ID][LoadingSite Resolver] token response ${JSON.stringify(response)}`)
        }),
        catchError((tokenError) => {
          this.logger.warn(`[OPAQUE-ID][LoadingSite Resolver] token lookup failed, trying legacy encrypted id. error=${JSON.stringify(tokenError)}`);
          return from(this.encryptionService.decrypt(routeId)).pipe(
            switchMap((decodedId: any) =>
              this.loadingsiteService.getLoadingSiteById(decodedId).pipe(
                tap((response) => {
                  this.logger.debug(`[OPAQUE-ID][LoadingSite Resolver] legacy response ${JSON.stringify(response)}`)
                }),
                catchError((error) => {
                  this.logger.error(`[OPAQUE-ID][LoadingSite Resolver] legacy lookup error ${JSON.stringify(error)}`);
                  this.router.navigate(['/error']);
                  return of(null);
                })
              )
            ),
            catchError((error: any) => {
              this.logger.error(`[OPAQUE-ID][LoadingSite Resolver] legacy decrypt error ${error}`);
              this.router.navigate(['/site-locations']);
              return of(null);
            })
          );
        })
      );
    } else {
      this.router.navigate(['/site-locations']);
      return of(null);
    }
  }
}
